@import '../../../assets/styles/variables';
@import '../../../assets/styles/typography';
@import '../../../../node_modules/@cpt/pci/postnl-styles/settings';
@import '../../../../node_modules/@cpt/pci/postnl-styles/tools/utilities';

.pnl-header__main--mobile {
    display: block;
    height: 44px;
}

.pnl-navigation__link--home-mobile {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);

    img {
        width: 2.5em;
        height: 2.5em;
    }

    &:focus:not(:focus-visible) {
        outline: none;
    }

    &:focus-visible {
        outline: 2px solid $color-border-focus-outline;
        outline-offset: 2px;
        border-radius: 0.25rem;
    }
}
